import type {
  EditorBlock,
  Context,
  FontUpdateProgress,
  Selection,
  TextMenuState,
} from '@getaccept/editor-lib';
import type {
  MenuCommand,
  ImageMenuState,
  Hover,
  ImageSearchState,
  NodeSettingsState,
} from '../types';
import type { ContentRequest } from '../api/services/types/requests';

export interface EditorUiState {
  context: Context;
  fontUpdateProgress?: FontUpdateProgress;
  selected: Selection;
  hovered: Hover;
  textMenuState: TextMenuState;
  imageMenuState: ImageMenuState;
  menuCommand: MenuCommand;
  updateQueue: UpdateRequest[];
  isUpdating: boolean;
  blocksToUpdate: { block: EditorBlock; noUpdate: boolean }[];
  imageSearchState: ImageSearchState;
  nodeSettingsState: NodeSettingsState;
  alert: { message: string; contentUpdateFailed: boolean };
  isSigning: boolean;
  viewUpdateFailed: boolean;
  viewUpdateSuccess: boolean;
  formDragAndDropActive: boolean;
}

export interface UpdateRequest {
  type: ContentRequestType;
  payload: ContentRequest;
  blocksBeforeUpdate: EditorBlock[];
}

export enum ContentRequestType {
  UpdateCells,
  CreateRow,
  CreateSection,
  SplitTextCreateRow,
  DeleteRow,
  UpdateRow,
  UpdateSection,
  MoveSection,
  MoveRow,
  MoveCell,
  UpdateNode,
  DeleteSection,
  UpdateContent,
  ConvertToImagesPostLink,
}
